import LinearProgress from '@mui/material/LinearProgress'
import { keyframes, styled } from '@mui/material/styles'

type Props = {
  autoHideDuration: number
}

const LinearProgressWithTimer: React.FC<Props> = ({ autoHideDuration }) => {
  return (
    <Root>
      <StyledLinearProgress autoHideDuration={autoHideDuration} variant="indeterminate" />
    </Root>
  )
}

const Root = styled('div')({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
})

const animation = keyframes({
  '0%': {
    left: '-35%',
    right: '100%',
  },
  '100%': {
    left: '0%',
    right: '0%',
  },
})

const StyledLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'autoHideDuration',
})<Props>(({ autoHideDuration }) => ({
  '& .MuiLinearProgress-bar1Indeterminate': {
    width: 'auto',
    animation: `${animation} linear forwards`,
    animationDuration: `${autoHideDuration - 500}ms`,
  },
  '& .MuiLinearProgress-bar2Indeterminate': {
    display: 'none',
  },
}))

export default LinearProgressWithTimer
